import { render, staticRenderFns } from "./CreateProjectModal.vue?vue&type=template&id=eab48120&scoped=true&"
import script from "./CreateProjectModal.vue?vue&type=script&lang=js&"
export * from "./CreateProjectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eab48120",
  null
  
)

export default component.exports